import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import LoadingOverlay from "~/components/LoadingOverlay";
import noop from "~/utils/noop";

interface EmbedContainerProps {
  iframeSrc?: string;
  loading?: boolean;
  messageHandler?: (event: MessageEvent) => void;
}

const EmbedContainer = ({ iframeSrc, loading, messageHandler = noop }: EmbedContainerProps) => {
  const [iframeLoading, setIframeLoading] = useState(true);

  useEffect(() => {
    window.addEventListener("message", messageHandler);
    return () => window.removeEventListener("message", messageHandler);
  }, [messageHandler]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
        userSelect: "none",
        overflow: "hidden",
      }}
    >
      <LoadingOverlay when={loading || iframeLoading} />
      <Box
        key={iframeSrc}
        component="iframe"
        src={iframeSrc}
        sandbox="allow-same-origin allow-scripts allow-downloads allow-modals allow-forms allow-popups"
        onLoad={() => setIframeLoading(false)}
        width="100%"
        height="100%"
        border="none"
      />
    </Box>
  );
};

export default EmbedContainer;
